module.exports = __webpack_public_path__ + "img/10.796f3a0e.png";